import React from "react";
import { ApiHelper, DateHelper, DeviceInterface, EnvironmentHelper, FcmMessage, UserHelper, ToastHelper } from "../../helpers";
import { DisplayBox } from "../../components"
import { Row, Col, FormControl, Button } from "react-bootstrap";
import { VerboseLogs } from "./VerboseLogs";


interface Props {
  device: DeviceInterface
}

export const Device: React.FC<Props> = props => {
  const [commandName, setCommandName] = React.useState("updateInstructions");
  const details: any = (props.device.deviceDetails) ? (() => {
    try {
      return JSON.parse(props.device.deviceDetails);
    } catch (error) {
      return { deviceName: props.device.deviceDetails };
    }
  })() : {}


  const handleSendCommand = () => {
    const command: FcmMessage = { action: commandName, data: "" }
    ApiHelper.post("/devices/sendMessage/" + props.device.id, command);
    ToastHelper.success("Command sent");
  }

  const getDetails = () => {
    if (details.appVersion) return (<>
      <Row><Col><b>App Version:</b> {details.appVersion}</Col></Row>
      <Row><Col><b>Hardware:</b> {details.deviceType + ": " + details.manufacturer + " - " + details.deviceId}</Col></Row>
      <Row><Col><b>Report Time:</b> {DateHelper.getDisplayDuration(DateHelper.convertToDate(props.device.lastUpdated))} ago</Col></Row>
      <Row><Col><b>Device Time:</b> {details.deviceTime}</Col></Row>
      <Row><Col><b>Last Action:</b> {details.currentAction}</Col></Row>
      <Row><Col><b>Action Time:</b> {details.currentActionTime}</Col></Row>
    </>)
  }

  var imgUrl = EnvironmentHelper.ContentRoot + "/devicescreenshots/" + props.device.id + ".jpg";
  if (props.device.lastUpdated) {
    const t = new Date(Date.parse(props.device.lastUpdated.toString()));
    imgUrl += "?ts=" + t.getTime().toString();
  }

  const getAdminOptions = () => {
    if (UserHelper.checkAccess("admin")) {
      return (<>
        <br />
        {getCommands()}
        <VerboseLogs deviceId={props.device.id} />
      </>);
    } else return <></>
  }

  const handleChange = (e: any) => {
    setCommandName(e.currentTarget.value);
  }

  const getCommands = () => {
    return (<Row>
      <Col>
        <FormControl as="select" onChange={handleChange} value={commandName}>
          <option value="updateInstructions">Update Instructions</option>
          <option value="clearCache">Clear Cache</option>
          <option value="health">Update Health</option>
          <option value="restart">Restart</option>
          <option value="enableVerbose">Enable Verbose</option>
          <option value="disableVerbose">Disable Verbose</option>
        </FormControl>
      </Col>
      <Col className="d-grid">
        <Button type="submit" variant="primary" className="w-100" onClick={handleSendCommand}>
          Send Command
        </Button>
      </Col>
    </Row>);
  }

  return (
    <DisplayBox headerIcon="fas fa-tv" headerText={"Paired Device: " + details.deviceName || props.device.ipAddress}>
      <img src={imgUrl} alt="Screenshot" className="img-fluid" />
      {getDetails()}
      {getAdminOptions()}

    </DisplayBox>
  );


}